import React, {useState, useEffect} from "react";
import { Outlet, useLocation, redirect } from "react-router-dom";
import { Container, Row } from "reactstrap";
import { toast } from 'react-toastify';

import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";

export async function action() {
  console.log('authLogin');
  return redirect('/admin/Dashboard');
}

const AuthLayout = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  useEffect(() => {
    if (isError) {
      toast.warn('Erro de Autenticação! Verifique o nome de usuário e senha.', {
        containerId: 'B'
      });
      setIsError(false);
    }
  }, [isError]);

  return (
    <>
      <div className="main-content" ref={mainContent}>
        <AuthNavbar />
        <div className="header bg-gradient-info py-7 py-lg-8">
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        {/* Page content */}
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Outlet />
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </>
  );
};

export default AuthLayout;
